import type { SearchCriteria } from '../model/types';

type DirectFlightDirection = Pick<SearchCriteria, 'destination'> & Partial<Pick<SearchCriteria, 'fromCity'>>;

export function isDirectFlightAvailable({ fromCity, destination }: DirectFlightDirection): boolean {
  if (!fromCity?.countriesWithDirectFlights || !destination || destination.kind === 'none') return false;

  return fromCity.countriesWithDirectFlights.includes(destination.country.id);
}

export function withAvailableDirectFlight(criteria: SearchCriteria): SearchCriteria {
  if (!criteria.directFlight || isDirectFlightAvailable(criteria)) return criteria;

  return { ...criteria, directFlight: undefined };
}
